export const getConfigWithParams = (
	newParams: Common.MapSimpleNullUndef,
	options: RA.IOptionsRestApi = {}
): RA.IOptionsRestApi => {
	const config = options.config || {};
	const oldParams = config.params || {};

	return {
		...options,
		config: {
			...config,
			params: {
				...oldParams,
				...newParams
			}
		}
	};
};
